<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      temporary
      app
      class="hidden-md-and-up">
      <v-list>
        <v-list-tile to="/">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-group
          v-for="menuItem in menu"
          v-model="menuItem.active"
          :key="menuItem.title"
          :prepend-icon="menuItem.action"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ menuItem.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-for="subItem in menuItem.items"
            :key="subItem.title"
            @click=""
          >
            <v-list-tile-content @click="mainPanel = subItem.panel; drawer = false">
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>{{ subItem.action }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      dark
      class="primary">
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <v-toolbar-side-icon class="hidden-sm-and-down"><img src="/static/icon.ico" class="ml-3" height="38"/></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-menu
          offset-y
          open-on-hover
          v-for="menuItem in menu"
          :key="menuItem.title">
          <v-btn
            flat
            slot="activator">
            {{menuItem.title}}
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="(subItem, index) in menuItem.items"
              :key="index"
              @click="mainPanel = subItem.panel"
            >
              <v-list-tile-title>
                {{ subItem.title }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-menu offset-y offset-x="">
        <v-btn
          slot="activator"
          icon>
          <v-icon>person</v-icon>
        </v-btn>
        <v-list subheader>
          <v-subheader>{{user.name}}</v-subheader>
          <v-list-tile @click="signOut">
            <v-list-tile-title>Sair</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content class="page-container">
      <v-container
        fluid
        grid-list-lg>

          <v-layout row wrap>

            <v-flex xs12 v-show="mainPanel === 'patient'">
              <v-card>
                <v-card-title primary-title>
                  <v-container fluid class="pa-0">
                    <v-layout row wrap>
                      <v-flex md4 style="display: flex; justify-content: center; align-items: center;">
                        <v-avatar size="160" color="grey lighten-2" style="flex: 0;">
                          <v-icon size="140" color="pink lighten-2">pregnant_woman</v-icon>
                        </v-avatar>
                      </v-flex>
                      <v-flex md8>
                        <v-list>
                          <v-list-tile>
                            <v-list-tile-action>
                              <v-icon>person</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-content>
                              <v-list-tile-title :title="study.patientName">{{study.patientName}}</v-list-tile-title>
                              <small>{{ study.patId }}</small>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-divider inset></v-divider>

                          <v-list-tile>
                            <v-list-tile-action>
                              <v-icon>cake</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-content>
                              <v-list-tile-title> {{study.birthDate | formatDate}} <small>({{study.birthDate | ageFriendly}})</small></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-divider inset></v-divider>

                          <v-list-tile>
                            <v-list-tile-action>
                              <v-icon>phone</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-content>
                              <v-list-tile-title :title="study.phone | phone">{{study.phone | phone}}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-divider inset></v-divider>

                          <v-list-tile>
                            <v-list-tile-action>
                              <v-icon>email</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-content>
                              <v-list-tile-title :title="study.email">{{study.email}}</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-divider inset></v-divider>

                          <v-list-tile>
                            <v-list-tile-action>
                              <v-icon>event</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-content>
                              <v-list-tile-title> {{study.serviceDate | formatDateTime}} </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>

                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-title>
                <!--<v-card-actions>-->
                <!--<v-btn flat color="red">UltraFetal</v-btn>-->
                <!--<v-btn flat color="red">WhatsApp</v-btn>-->
                <!--<v-btn flat color="red">Laudo</v-btn>-->
                <!--</v-card-actions>-->
              </v-card>

              <v-timeline>
                <template
                  v-for="studyItem in studiesHistory">

                  <v-timeline-item
                    color="red lighten-2"
                    large
                  >
                    <span slot="opposite">{{studyItem.serviceDate | formatDate}}</span>
                    <span slot="icon">{{ studyItem.items ? studyItem.items.length : 0 }}</span>
                    <v-card class="elevation-2">
                      <v-card-title class="subheading">{{studyItem.title}}</v-card-title>
                    </v-card>
                  </v-timeline-item>

                </template>
              </v-timeline>
            </v-flex>

            <v-flex xs12 v-show="mainPanel === 'media'" v-for="item in studies" :key="item.id">
              <v-card>
                <v-container fluid>
                  <v-layout row wrap>
                    <v-flex md12 lg12>
                      <div class="subheading">{{ item.accessionNo }} - {{ item.title }}</div>
                      <div class="caption">Dr(a). {{ item.resource }} - {{ item.room }}</div>
                    </v-flex>
                    <v-flex xs12 v-if="item.pathVideo !== null">
                      <iframe
                        :src="video(item)"
                        width="100%"
                        height="300px"
                        style="border: 0px"
                        allowfullscreen="allowfullscreen"
                        mozallowfullscreen="mozallowfullscreen"
                        msallowfullscreen="msallowfullscreen"
                        oallowfullscreen="oallowfullscreen"
                        webkitallowfullscreen="webkitallowfullscreen"/>
                    </v-flex>
                    <v-flex
                      v-for="(image, i) in item.imagesURL"
                      :key="image"
                      xs12 md4>
                      <v-card flat tile>
                        <v-img
                          :src="image"
                          :lazy-src="`${image}&rows=50`"
                          @click="slideIndex = i"
                          style="background-color: black; height: 150px;">
                           <v-layout
                              slot="placeholder"
                              fill-height
                              align-center
                              justify-center
                              ma-0>
                              <v-progress-circular indeterminate color="grey lighten-5"/>
                            </v-layout>
                        </v-img>
                      </v-card>
                    </v-flex>
                    <vue-gallery :images="item.imagesURL" :index="slideIndex" @close="slideIndex = null"></vue-gallery>
                  </v-layout>
                  <!--<v-layout row wrap v-else>-->
                    <!--<v-flex md12 lg12 style="display: flex; justify-content: center; align-items: center;">-->
                      <!--<v-icon size="140" color="primary lighten-1">image</v-icon>-->
                    <!--</v-flex>-->
                    <!--<v-flex md12 lg12 style="display: flex; justify-content: center; align-items: center;">-->
                      <!--Nenhuma imagem ou video foi encontrado-->
                    <!--</v-flex>-->
                  <!--</v-layout>-->
                </v-container>
              </v-card>
            </v-flex>

            <v-flex xs12 v-show="mainPanel === 'observations'">
              <v-card>
                <v-card-title primary-title>
                  <h4>OBSERVAÇÕES</h4>
                </v-card-title>

                <v-container>
                  <quill-editor ref="myTextEditor"
                                v-model="report.conclusao.observacoes"
                                :config="editorOption"
                                class="quill-editor-new">
                  </quill-editor>
                </v-container>

              </v-card>
            </v-flex>

            <v-layout row wrap v-for="form in forms.components" :key="form.key" v-show="mainPanel === form.key">

              <v-flex xs12>
                <v-card>
                  <v-toolbar>
                    <v-toolbar-title>{{form.label}}</v-toolbar-title>
                    <v-toolbar-items>
                      <v-menu>
                        <v-btn flat slot="activator">Informações <v-icon>arrow_drop_down</v-icon></v-btn>
                        <v-list>
                          <v-list-tile
                            v-for="panel in form.components"
                            :key="`${form.key}.${panel.key}`"
                            @click=""
                          >
                            <v-list-tile-title v-text="panel.label"></v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </v-toolbar-items>
                  </v-toolbar>
                </v-card>
              </v-flex>

              <v-flex d-flex xs12 v-for="panel in form.components" :key="`${form.key}.${panel.key}`">
                <v-card>
                  <v-card-title primary-title>
                    <h4>{{panel.label}}</h4>
                  </v-card-title>

                  <v-container>
                    <v-layout row wrap>
                      <v-flex :class="component.style || 'sx12 md6'"
                              v-for="component in panel.components"
                              :key="`${form.key}.${panel.key}.${component.key || component.label}`"
                              v-show="component.vShow == undefined || component.vShow"
                      >

                        <v-text-field v-if="component.type === 'textfield'" hide-details dense
                                      v-model="forms.values[`${form.key}.${panel.key}.${component.key || component.label}`]"
                                      :label="component.label"
                                      :placeholder="component.placeholder"
                                      :required="component.required"
                                      :disabled="component.disabled"
                                      :suffix="component.suffix"
                                      :prefix="component.prefix || ' '"
                                      @change="calcs(`${form.key}.${panel.key}.${component.key || component.label}`)"
                        >
                        </v-text-field>

                        <v-select v-if="component.type === 'select'" hide-details dense
                                  v-model="forms.values[`${form.key}.${panel.key}.${component.key || component.label}`]"
                                  :label="component.label"
                                  :placeholder="component.placeholder"
                                  :required="component.required"
                                  :disabled="component.disabled"
                                  :suffix="component.suffix"
                                  :prefix="component.prefix || ' '"

                                  :items="component.items"
                                  :multiple="component.multiple"
                        ></v-select>

                        <v-radio-group v-if="component.type === 'radio'" hide-details dense
                                       v-model="forms.values[`${form.key}.${panel.key}.${component.key || component.label}`]"
                                       :label="component.label"
                                       :placeholder="component.placeholder"
                                       :required="component.required"
                                       :disabled="component.disabled"
                                       :suffix="component.suffix"
                                       :prefix="component.prefix"

                                       :column="component.column"
                                       :row="component.row"
                        >
                          <v-radio hide-details dense
                            v-for="item in component.items"
                            :key="item"
                            :label="item"
                            :value="item"
                          ></v-radio>
                        </v-radio-group>

                        <v-layout align-center row fill-height v-if="component.type === 'checkbox'">
                          <v-flex>
                            <label class="v-label theme--light" v-if="component.label">
                              {{component.label}}
                            </label>
                          </v-flex>

                          <v-spacer v-if="component.label"></v-spacer>

                          <v-checkbox v-model="forms.values[`${form.key}.${panel.key}.${component.key || component.label}`]" hide-details dense
                                      :label="item"
                                      :value="item"
                                      :key="item"
                                      :placeholder="component.placeholder"
                                      :required="component.required"
                                      :disabled="component.disabled"
                                      :suffix="component.suffix"
                                      :prefix="component.prefix"

                                      :multiple="component.multiple"
                                      v-for="item in component.items"
                          ></v-checkbox>
                        </v-layout>

                        <div v-if="component.type === 'label'"
                             class="v-label theme--light">
                          {{component.label}}
                        </div>

                        <quill-editor v-if="component.type === 'texteditor'"
                                      ref="myTextEditor"
                                      v-model="forms.values[`${form.key}.${panel.key}.${component.key || component.label}`]"
                                      class="quill-editor"
                                      :config="component.editorOption"
                        >
                        </quill-editor>

                      </v-flex>

                    </v-layout>
                  </v-container>

                </v-card>
              </v-flex>
            </v-layout>

            <div class="printable" v-if="mainPanel === 'preview'">

              <v-flex xs12 class="no-printable">
                <v-card>
                  <v-toolbar>
                    <v-toolbar-title>RESUMO</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="print" icon><v-icon>print</v-icon></v-btn>
                  </v-toolbar>
                </v-card>
              </v-flex>

              <v-flex xs12 v-for="form in forms.components" :key="form.key"
                    v-if="form.components.find(p => p.components.find(x => forms.values[`${form.key}.${p.key}.${x.key || x.label}`]))">
                <v-card>
                  <v-card-title primary-title>
                    <h2>{{form.label}}</h2>
                  </v-card-title>

                  <v-container v-for="panel in form.components" :key="`print.${form.key}.${panel.key}`"
                               v-if="panel.components.find(x => forms.values[`${form.key}.${panel.key}.${x.key || x.label}`])"
                  >

                    <v-layout row wrap>

                      <v-flex xs12>
                        <h4 class="text-uppercase">{{panel.label}}</h4>
                      </v-flex>

                      <v-flex :class="component.styleReport || 'sx12 md6'"
                              v-for="component in panel.components"
                              :key="`print.${form.key}.${panel.key}.${component.key || component.label}`"
                              v-if="forms.values[`${form.key}.${panel.key}.${component.key || component.label}`] || component.type === 'label'">

                        <template v-if="component.type === 'texteditor'" >
                          <span class="body-2">{{component.label}}</span>
                          <div class="ql-editor" v-html="forms.values[`${form.key}.${panel.key}.${component.key || component.label}`]"></div>
                        </template>

                        <v-container v-else fluid style="padding: 0px">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <div v-if="component.type === 'label'"
                                   class="v-label v-label--active theme--light">
                                {{component.label}}
                              </div>
                              <span v-else class="body-2">{{component.label}}</span>
                            </v-flex>
                            <v-flex :style="component.chart ? 'xs2' : 'xs6'" xs3>
                              <div>{{ component, forms.values[`${form.key}.${panel.key}.${component.key || component.label}`] | componentValue }}</div>
                            </v-flex>
                            <v-flex xs3 v-if="component.chart">
                              <div class="slider-chart">
                                <div class="v-input v-input--slider v-input--slider--ticks v-input--is-label-active v-input--is-dirty theme--light">
                                  <div class="v-input__control">
                                    <div class="v-input__slot">
                                      <div class="v-slider" style="margin-top: -5px;">
                                        <div class="v-slider__track__container">
                                          <div class="v-slider__track" style="left: 5%; right: auto; width: 90%;"></div>
                                          <div class="v-slider__track-fill primary"
                                               style="left: 0px; right: auto; width: 50%;"></div>
                                        </div>
                                        <div class="v-slider__ticks-container"><span
                                          class="v-slider__ticks v-slider__ticks--always-show"
                                          style="border-width: 0px; border-radius: 50%; transform: translateX(-2px) translateY(-1px); left: 0%;"></span><span
                                          class="v-slider__ticks v-slider__ticks--always-show"
                                          style="opacity: 0.4; border-width: 1px; height: 14px; transform: translateX(-1px) translateY(-6px); left: 5%;"></span><span
                                          class="v-slider__ticks v-slider__ticks--always-show"
                                          style="opacity: 0.4; border-width: 1px; height: 12px; transform: translateX(-1px) translateY(-5px); left: 50%;"></span><span
                                          class="v-slider__ticks v-slider__ticks--always-show"
                                          style="opacity: 0.4; border-width: 1px; height: 14px; transform: translateX(-1px) translateY(-6px); left: 95%;"></span>
                                        </div>
                                        <div class="v-slider__thumb-container primary--text" :style="`left: ${forms.values[`${form.key}.${panel.key}.${component.key || component.label}`]}%;`">
                                          <div class="v-slider__thumb primary" style="width: 18px; height: 18px; left: -9px;"></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>

                      </v-flex>

                    </v-layout>

                  </v-container>

                </v-card>
              </v-flex>

              <v-flex xs12>
                <v-card>
                  <v-card-title primary-title>
                    <h2>Gráficos</h2>
                  </v-card-title>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <span class="body-2">Peso Fetal Estimado</span>
                        <line-chart :chartdata="randomChart"
                                    :options="chart.options"/>
                      </v-flex>
                      <v-flex xs12 md6>
                        <span class="body-2">Peso Fetal Estimado</span>
                        <line-chart :chartdata="randomChart"
                                    :options="chart.options"/>
                      </v-flex>
                      <v-flex xs12 md6>
                        <span class="body-2">Peso Fetal Estimado</span>
                        <line-chart :chartdata="randomChart"
                                    :options="chart.options"/>
                      </v-flex>
                      <v-flex xs12 md6>
                        <span class="body-2">Peso Fetal Estimado</span>
                        <line-chart :chartdata="randomChart"
                                    :options="chart.options"/>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </div>
          </v-layout>

      </v-container>
    </v-content>
  </div>
</template>

<script>
import axios from 'axios'
import {auth} from '@/store/firebase'
// import moment from 'moment'
import VueGallery from 'vue-gallery'
import {mapState} from 'vuex'
import {formatWadoRsToWado} from '../utils/dicom'
import StudyUtils from '../utils/studyUtils'
import {quillEditor} from 'vue-quill-editor'
import LineChart from '../components/charts/LineChart'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'Report',
  components: {
    LineChart,
    VueGallery,
    quillEditor
  },
  props: {
    id: {
      required: false
    },
    patId: {
      required: false
    },
    serviceDate: {
      required: false
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      company: (state) => state.company
    }),
    study () {
      return this.studies[0]
    },
    randomChart () {
      let normalData = [0, 250, 450, 800, 1250, 2000, 3000, 3500]
      return {
        labels: [14, 18, 22, 26, 30, 34, 38, 42],
        pointStyle: 'line',
        datasets: [
          {
            label: 'Exame',
            borderColor: '#000000',
            backgroundColor: '#000000',
            fill: false,
            pointStyle: 'cross',
            showLine: false,
            data: normalData.map(value => value * ((Math.random() * 0.3 - 0.15) + 1))
          },
          {
            label: '95%',
            borderColor: '#f87979',
            backgroundColor: '#f87979',
            fill: false,
            pointRadius: 0,
            data: normalData.map(value => value * 1.27)
          },
          {
            label: '50%',
            borderColor: '#73aef8',
            backgroundColor: '#73aef8',
            fill: false,
            pointRadius: 0,
            data: normalData
          },
          {
            label: '5%',
            borderColor: '#f8d41d',
            backgroundColor: '#f8d41d',
            fill: false,
            pointRadius: 0,
            data: normalData.map(value => value * 0.80)
          }
        ]
      }
    },
    mountFormObj () {
      let obj = {}
      for (let form in this.forms.components) {
        console.log(form.label)
        obj[form.key] = {}
        for (let panel in form.components) {
          console.log(panel.label)
          obj[panel.key] = {}
        }
      }
      return obj
    }
  },
  data () {
    return {
      drawer: false,
      activeTab: 0,
      chart: {
        options: {
          responsive: true
        }
      },
      forms: {
        values: {},
        events: {},
        components: [
          {
            label: '1º TRIMESTRE INICIAL',
            key: 'priTriInicial',
            components: [
              {
                label: 'INFORMAÇÕES',
                type: 'panel',
                key: 'exame',
                components: [
                  {
                    type: 'checkbox',
                    key: 'via',
                    label: 'Via do exame',
                    items: ['Abdominal', 'Transvaginal', 'Pélvica', 'Outros'],
                    style: 'xs12',
                    multiple: true
                  },
                  {
                    type: 'select',
                    key: 'indicacao',
                    label: 'Indicação do exame',
                    items: ['Datar gestação', 'Rastreio de aneuploidias', 'Sangramento', 'Diagnosticar gestação', 'Outros']
                  },
                  {
                    type: 'select',
                    key: 'qualidade',
                    label: 'Qualidade do exame',
                    items: ['Satisfatória', 'Prejudicado pela adiposidade materna', 'Prejudicado pela estática fetal', 'Prejudicado pela movimentação fetal', 'Outros']
                  }
                ]
              },
              {
                label: 'AVALIAÇÃO GESTAÇÃO',
                type: 'panel',
                key: 'avaliacaoGestacao',
                components: [
                  {
                    type: 'select',
                    key: 'sacoGestacional',
                    label: 'Saco gestacional',
                    items: ['Regular', 'Irregular', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'localizacao',
                    label: 'Localização',
                    items: ['Fundo uterino', 'Corporal', 'Colo', 'Cicatriz cesariana'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'qtdSacoGestacional',
                    label: 'Número de saco gestacional',
                    items: ['Um', 'Dois', 'Três', 'Quatro', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'embrioes',
                    label: 'Embriões',
                    items: ['Anembrionada', 'Gemelar', 'Triplo', 'Quádruplo', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'movimentosEmbrioes',
                    label: 'Movimentos embrionários',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'batimentosEmbrioes',
                    label: 'Batimentos embrionários/fetais',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'deslocamentoOvular',
                    label: 'Descolamento ovular',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  }
                ]
              },
              {
                label: 'BIOMETRIA EMBRIONÁRIA/FETAL',
                type: 'panel',
                key: 'biometria',
                components: [
                  {
                    type: 'label',
                    label: 'Saco gestacional',
                    style: 'xs12'
                  },
                  {
                    type: 'textfield',
                    key: 'long',
                    label: 'Long.',
                    suffix: 'mm',
                    style: 'xs6 md3'
                  },
                  {
                    type: 'textfield',
                    key: 'ap',
                    label: 'Ap.',
                    suffix: 'mm',
                    style: 'xs6 md3'
                  },
                  {
                    type: 'textfield',
                    key: 'transv',
                    label: 'Transv.',
                    suffix: 'mm',
                    style: 'xs6 md3'
                  },
                  {
                    type: 'textfield',
                    key: 'idadeGestaSaco',
                    label: 'Idade Gestacional Saco',
                    style: 'xs6 md3',
                    formulas: {
                      default: 'daya',
                      authors: {
                        daya: {
                          apiPath: '/calc/saco-gestacional/daya/v1',
                          params: {
                            longi: 'priTriInicial.biometria.long',
                            ap: 'priTriInicial.biometria.ap',
                            transv: 'priTriInicial.biometria.transv',
                            idadeGestacionalEmDias: 'priTriInicial.idadeGestacional.calculada'
                          }
                        }
                      }
                    },
                    disabled: true
                  },
                  {
                    type: 'textfield',
                    key: 'ccn',
                    label: 'CCN',
                    suffix: 'mm'
                  },
                  {
                    type: 'textfield',
                    key: 'idadeGestaCCN',
                    label: 'IG CCN',
                    style: 'xs6',
                    formulas: {
                      default: 'robinson',
                      authors: {
                        hadlock: {
                          apiPath: '/calc/ccn/hadlock/v1',
                          params: {
                            ccn: 'priTriInicial.biometria.ccn',
                            idadeGestacionalEmDias: 'priTriInicial.idadeGestacional.calculada'
                          }
                        },
                        robinson: {
                          apiPath: '/calc/ccn/robinson/v1',
                          params: {
                            ccn: 'priTriInicial.biometria.ccn',
                            idadeGestacionalEmDias: 'priTriInicial.idadeGestacional.calculada'
                          }
                        }
                      }
                    },
                    disabled: true
                  },
                  {
                    type: 'textfield',
                    key: 'visiculaVitelinia',
                    label: 'Vesícula vitelínica',
                    suffix: 'mm'
                  }
                ]
              },
              {
                label: 'OVÁRIOS',
                type: 'panel',
                key: 'ovarios',
                components: [
                  {
                    type: 'label',
                    label: 'Direito',
                    style: 'xs12'
                  },
                  {
                    type: 'textfield',
                    key: 'direitoLong',
                    label: 'Longitudinal',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'direitoAnte',
                    label: 'Anteroposterior',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'direitoTransv',
                    label: 'Transversa',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'direitoVolume',
                    label: 'Volume',
                    suffix: 'mm',
                    style: 'xs6 md2',
                    disabled: true,
                    formulas: {
                      default: 'general',
                      authors: {
                        general: {
                          apiPath: '/calc/volume-ovario/geral/v1',
                          params: {
                            longi: 'priTriInicial.ovarios.direitoLong',
                            ap: 'priTriInicial.ovarios.direitoAnte',
                            transv: 'priTriInicial.ovarios.direitoTransv'
                          }
                        }
                      }
                    }
                  },
                  {
                    type: 'select',
                    key: 'direitoAspecto',
                    label: 'Aspecto',
                    style: 'xs6 md4',
                    items: ['Normal', 'Alterado', 'Não Visto', 'Outros']
                  },
                  {
                    type: 'label',
                    label: 'Esquerdo',
                    style: 'xs12'
                  },
                  {
                    type: 'textfield',
                    key: 'esquerdoLong',
                    label: 'Longitudinal',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'esquerdoAnte',
                    label: 'Anteroposterior',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'esquerdoTransv',
                    label: 'Transversa',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'esquerdoVolume',
                    label: 'Volume',
                    suffix: 'mm',
                    style: 'xs6 md2',
                    disabled: true,
                    formulas: {
                      default: 'general',
                      authors: {
                        general: {
                          apiPath: '/calc/volume-ovario/geral/v1',
                          params: {
                            longi: 'priTriInicial.ovarios.esquerdoLong',
                            ap: 'priTriInicial.ovarios.esquerdoAnte',
                            transv: 'priTriInicial.ovarios.esquerdoTransv'
                          }
                        }
                      }
                    }
                  },
                  {
                    type: 'select',
                    key: 'esquerdoAspecto',
                    label: 'Aspecto',
                    style: 'xs6 md4',
                    items: ['Normal', 'Alterado', 'Não Visto', 'Outros']
                  }
                ]
              },
              {
                label: 'IDADE GESTACIONAL',
                type: 'panel',
                key: 'idadeGestacional',
                components: [
                  {
                    type: 'textfield',
                    key: 'calculada',
                    label: 'Calculada',
                    suffix: 'Semanas, dias',
                    disabled: false
                  },
                  {
                    type: 'select',
                    key: 'calculo',
                    label: 'Cálculo',
                    items: ['Última menstruação', 'Exame anterior', 'Data provável do parto', 'Data implantação ovular', 'Informada pela paciente', 'Desconhecido']
                  },
                  {
                    type: 'textfield',
                    key: 'medida',
                    label: 'Medida neste exame',
                    suffix: 'Semanas, dias',
                    disabled: true
                  }
                ]
              },
              {
                label: 'CONCLUSÃO',
                type: 'panel',
                key: 'conclusao',
                components: [
                  {
                    type: 'texteditor',
                    key: 'conclusao',
                    editorOption: {},
                    style: 'xs12'
                  }
                ]
              }
            ]
          },
          {
            label: '1º TRIMESTRE RASTREIO',
            key: 'priTriRastreio',
            components: [
              {
                label: 'INFORMAÇÕES',
                type: 'panel',
                key: 'exame',
                components: [
                  {
                    type: 'checkbox',
                    key: 'via',
                    label: 'Via do exame',
                    items: ['Abdominal', 'Transvaginal', 'Pélvica', 'Outros'],
                    style: 'xs12',
                    multiple: true
                  },
                  {
                    type: 'select',
                    key: 'indicacao',
                    label: 'Indicação do exame',
                    items: ['Datar gestação', 'Rastreio de aneuploidias', 'Sangramento', 'Diagnosticar gestação', 'Outros']
                  },
                  {
                    type: 'select',
                    key: 'qualidade',
                    label: 'Qualidade do exame',
                    items: ['Satisfatória', 'Prejudicado pela adiposidade materna', 'Prejudicado pela estática fetal', 'Prejudicado pela movimentação fetal', 'Outros']
                  }
                ]
              },
              {
                label: 'AVALIAÇÃO GESTAÇÃO',
                type: 'panel',
                key: 'avaliacaoGestacao',
                components: [
                  {
                    type: 'select',
                    key: 'sacoGestacional',
                    label: 'Saco gestacional',
                    items: ['Regular', 'Irregular', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'qtdSacoGestacional',
                    label: 'Número de saco gestacional',
                    items: ['Um', 'Dois', 'Três', 'Quatro', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'fetos',
                    label: 'Fetos',
                    items: ['Anembrionada', 'Gemelar', 'Triplo', 'Quádruplo', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'textfield',
                    key: 'corionicidade',
                    label: 'Corionicidade',
                    vShow: true
                  },
                  {
                    type: 'textfield',
                    key: 'amniocidade',
                    label: 'Amniocidade'
                  },
                  {
                    type: 'select',
                    key: 'movimentosFetais',
                    label: 'Movimentos fetais',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'batimentosFetais',
                    label: 'Batimentos fetais',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'textfield',
                    key: 'bcf',
                    label: 'BCF',
                    style: 'xs12 md4'
                  }
                ]
              },
              {
                label: 'BIOMETRIA EMBRIONÁRIA/FETAL',
                type: 'panel',
                key: 'biometria',
                components: [
                  {
                    type: 'textfield',
                    key: 'ccn',
                    label: 'CCN',
                    suffix: 'mm',
                    style: 'xs6 md3'
                  },
                  {
                    type: 'textfield',
                    key: 'dbp',
                    label: 'DBP',
                    suffix: 'mm',
                    style: 'xs6 md3'
                  },
                  {
                    type: 'textfield',
                    key: 'CC',
                    label: 'CC',
                    suffix: 'mm',
                    style: 'xs6 md3'
                  },
                  {
                    type: 'textfield',
                    key: 'ca',
                    label: 'CA',
                    suffix: 'mm',
                    style: 'xs6 md3'
                  },
                  {
                    type: 'textfield',
                    key: 'cf',
                    label: 'CF',
                    suffix: 'mm',
                    style: 'xs6 md3'
                  },
                  {
                    type: 'textfield',
                    key: 'cu',
                    label: 'CU',
                    suffix: 'mm',
                    style: 'xs6 md3'
                  },
                  {
                    type: 'textfield',
                    key: 'tn',
                    label: 'TN',
                    suffix: 'mm',
                    style: 'xs6 md3'
                  },
                  {
                    type: 'textfield',
                    key: 'ductoVenoso',
                    label: 'Ducto Venoso',
                    suffix: 'mm',
                    style: 'xs6 md3'
                  },
                  {
                    type: 'select',
                    key: 'ossoNasal',
                    label: 'Osso Nasal',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md6'
                  },
                  {
                    type: 'select',
                    key: 'regurgitacao',
                    label: 'Regurgitação Tricúspide',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md6'
                  },
                  {
                    type: 'label',
                    key: 'dopplerUtirinas',
                    label: 'Doppler das Uterinas',
                    style: 'xs12'
                  },
                  {
                    type: 'textfield',
                    key: 'piUterinaEsquerda',
                    label: 'PI da uterina esquerda',
                    suffix: 'mm',
                    style: 'xs6 md4'
                  },
                  {
                    type: 'textfield',
                    key: 'piUterinaDireita',
                    label: 'PI da uterina direita',
                    suffix: 'mm',
                    style: 'xs6 md4'
                  },
                  {
                    type: 'textfield',
                    key: 'piUterinaMedia',
                    label: 'PI da uterina (Média)',
                    suffix: 'mm',
                    disabled: true,
                    style: 'xs6 md4'
                  }
                ]
              },
              {
                label: 'ANATOMIA FETAL',
                type: 'panel',
                key: 'anatomiaFetal',
                components: [
                  {
                    type: 'radio',
                    key: 'cranio',
                    label: 'Crânio',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    row: false,
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'ventriculosLaterais',
                    label: 'Ventrículos laterais',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    row: false,
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'orbitas',
                    label: 'Órbitas',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'colunaVertebral',
                    label: 'Coluna vertebral',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'estomago',
                    label: 'Estômago',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'rinsBexiga',
                    label: 'Rins e bexiga',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'camarasCardiacas',
                    label: '4 câmaras cardíacas',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'viasSaida',
                    label: 'Vias de saída',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'paredeAbdominal',
                    label: 'Parede abdominal',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'membros',
                    label: 'Membros',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'subcutaneo',
                    label: 'Subcutâneo',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  }
                ]
              },
              {
                label: 'RISCO TRISSOMIA',
                type: 'panel',
                key: 'avalRiscoTrissomia',
                components: [
                  {
                    type: 'textfield',
                    key: 'idadeMaterna',
                    label: 'Idade materna na data provável do parto',
                    disabled: true,
                    style: 'xs12'
                  },
                  {
                    type: 'textfield',
                    key: 'riscoTrissomia21',
                    label: 'Risco de trissomia 21 pela idade materna',
                    disabled: true,
                    style: 'xs12 md8'
                  },
                  {
                    type: 'textfield',
                    key: 'riscoTrissomia21Corrigido',
                    label: 'Corrigido',
                    disabled: true,
                    style: 'xs12 md4'
                  },
                  {
                    type: 'textfield',
                    key: 'riscoTrissomia13',
                    label: 'Risco de trissomia 13 pela idade materna',
                    disabled: true,
                    style: 'xs12 md8'
                  },
                  {
                    type: 'textfield',
                    key: 'riscoTrissomia13Corrigido',
                    label: 'Corrigido',
                    disabled: true,
                    style: 'xs12 md4'
                  },
                  {
                    type: 'textfield',
                    key: 'riscoTrissomia18',
                    label: 'Risco de trissomia 18 pela idade materna',
                    disabled: true,
                    style: 'xs12 md8'
                  },
                  {
                    type: 'textfield',
                    key: 'riscoTrissomia18Corrigido',
                    label: 'Corrigido',
                    disabled: true,
                    style: 'xs12 md4'
                  }
                ]
              },
              {
                label: 'IDADE GESTACIONAL',
                type: 'panel',
                key: 'idadeGestacional',
                components: [
                  {
                    type: 'textfield',
                    key: 'calculada',
                    label: 'Calculada',
                    suffix: 'Semanas, dias',
                    disabled: true
                  },
                  {
                    type: 'select',
                    key: 'calculo',
                    label: 'Cálculo',
                    items: ['Última menstruação', 'Exame anterior', 'Data provável do parto', 'Data implantação ovular', 'Informada pela paciente', 'Desconhecido']
                  },
                  {
                    type: 'textfield',
                    key: 'medida',
                    label: 'Medida neste exame',
                    suffix: 'Semanas, dias',
                    disabled: true
                  }
                ]
              },
              {
                label: 'CONCLUSÃO',
                type: 'panel',
                key: 'conclusao',
                components: [
                  {
                    type: 'texteditor',
                    key: 'conclusao',
                    editorOption: {},
                    style: 'xs12'
                  }
                ]
              }
            ]
          },
          {
            label: '2º e 3º TRIMESTRE',
            key: 'segTerTriRastreio',
            components: [
              {
                label: 'INFORMAÇÕES',
                type: 'panel',
                key: 'exame',
                components: [
                  {
                    type: 'checkbox',
                    key: 'via',
                    label: 'Via do exame',
                    items: ['Abdominal', 'Transvaginal', 'Outros'],
                    style: 'xs12',
                    multiple: true
                  },
                  {
                    type: 'select',
                    key: 'indicacao',
                    label: 'Indicação do exame',
                    items: ['Datar gestação', 'Rastreio de aneuploidias', 'Sangramento', 'Diagnosticar gestação', 'Outros']
                  },
                  {
                    type: 'select',
                    key: 'qualidade',
                    label: 'Qualidade do exame',
                    items: ['Satisfatória', 'Prejudicado pela adiposidade materna', 'Prejudicado pela estática fetal', 'Prejudicado pela movimentação fetal', 'Outros']
                  }
                ]
              },
              {
                label: 'AVALIAÇÃO GESTAÇÃO',
                type: 'panel',
                key: 'avaliacaoGestacao',
                components: [
                  {
                    type: 'select',
                    key: 'fetos',
                    label: 'Fetos',
                    items: ['Gemelar', 'Triplo', 'Quádruplo', 'Outros'],
                    style: 'xs12 md6'
                  },
                  {
                    type: 'select',
                    key: 'situacaoFetal',
                    label: 'Situação fetal',
                    items: ['Longitudinal', 'Transversal', 'Oblíqua'],
                    style: 'xs12 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'corionicidade',
                    label: 'Corionicidade',
                    vShow: true
                  },
                  {
                    type: 'textfield',
                    key: 'amniocidade',
                    label: 'Amniocidade'
                  },
                  {
                    type: 'select',
                    key: 'apresentacaoFetal',
                    label: 'Apresentação fetal',
                    items: ['Cefálica', 'Pélvica', 'Córmica', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'dorsoFetal',
                    label: 'Dorso fetal',
                    items: ['Anterior', 'Posterior', 'Lateral direita', 'Lateral esquerda', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'movimentosFetais',
                    label: 'Movimentos fetais',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'batimentosFetais',
                    label: 'Batimentos fetais',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'textfield',
                    key: 'bcf',
                    label: 'BCF',
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'placenta',
                    label: 'Placenta',
                    items: ['Anterior', 'Posterior', 'Lateral direita', 'Lateral esquerda', 'Prévia parcial', 'Prévia total', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'placentaMaturidade',
                    label: 'Maturidade placentária(GRANUMM)',
                    items: ['0', 'I', 'II', 'III'],
                    style: 'xs12 md4'
                  }
                ]
              },
              {
                label: 'BIOMETRIA EMBRIONÁRIA/FETAL',
                type: 'panel',
                key: 'biometria',
                components: [
                  {
                    type: 'textfield',
                    key: 'diametroBiparietal',
                    label: 'Diâmetro biparietal',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'circunferenciaCraniana',
                    label: 'Circunferência craniana',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'circunferenciaAbdominal',
                    label: 'Circunferência abdominal',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'comprimentoFemur',
                    label: 'Comprimento do fêmur',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'comprimentoUmero',
                    label: 'Comprimento do úmero',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'relacaoCCCA',
                    label: 'Relação CC/CA',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'relacaoFemurCA',
                    label: 'Relação Fêmur/CA',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'relacaoFemurCC',
                    label: 'Relação Fêmur/CC',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'pesoEstimado',
                    label: 'Peso estimado (± 15%)',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'comprimentoEstimado',
                    label: 'Comprimento estimado',
                    suffix: 'mm',
                    style: 'xs12 md6'
                  }
                ]
              },
              {
                label: 'ANATOMIA FETAL',
                key: 'anatomiaFetal',
                type: 'panel',
                components: [
                  {
                    type: 'radio',
                    key: 'cranio',
                    label: 'Crânio',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'cerebro',
                    label: 'Cérebro',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'face',
                    label: 'Face',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'pescoco',
                    label: 'Pescoço',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'colunaVertebral',
                    label: 'Coluna vertebral',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'caixaToracica',
                    label: 'Caixa torácica',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'pulmoesCavidadePleural',
                    label: 'Pulmões e cavidade pleural',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'coracaoEspacoPericardico',
                    label: 'Coração e espaço pericárdico',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'diafragma',
                    label: 'Diafragma',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'paredeAbdominal',
                    label: 'Parede abdominal',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'estomagoIntestino',
                    label: 'Estômago e intestino',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'rins',
                    label: 'Rins',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'Bexiga',
                    label: 'bexiga',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'outrosOrgãosAbdominais',
                    label: 'Outros órgãos abdominais',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'membros',
                    label: 'Membros',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'cordaoUmbilical',
                    label: 'Cordão umbilical',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'tecidoCelularSubcutaneo',
                    label: 'Tecido celular subcutâneo',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  }
                ]
              },
              {
                label: 'AVALIAÇÃO BIOFÍSICA FETAL',
                type: 'panel',
                key: 'avalBiofisicaFetal',
                components: [
                  {
                    type: 'select',
                    key: 'movimentosRespiratorio',
                    label: 'Movimento respiratório',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'tonusFetal',
                    label: 'Tônus Fetal',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'liquidoAmniotico',
                    label: 'Líquido amniótico',
                    items: ['Normal', 'Diminuído', 'Aumentado'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'label',
                    key: 'labelILA',
                    label: 'ILA',
                    style: 'xs12'
                  },
                  {
                    type: 'textfield',
                    key: 'qse',
                    label: 'QSE',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'qie',
                    label: 'QIE',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'qsd',
                    label: 'QSD',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'qiq',
                    label: 'QID',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'total',
                    label: 'Total',
                    suffix: 'mm',
                    disabled: true,
                    style: 'xs6 md4'
                  }
                ]
              },
              {
                label: 'IDADE GESTACIONAL',
                type: 'panel',
                key: 'idadeGestacional',
                components: [
                  {
                    type: 'textfield',
                    key: 'calculada',
                    label: 'Calculada',
                    suffix: 'Semanas, dias',
                    disabled: true
                  },
                  {
                    type: 'select',
                    key: 'calculo',
                    label: 'Cálculo',
                    items: ['Última menstruação', 'Exame anterior', 'Data provável do parto', 'Data implantação ovular', 'Informada pela paciente', 'Desconhecido']
                  },
                  {
                    type: 'textfield',
                    key: 'medida',
                    label: 'Medida neste exame',
                    suffix: 'Semanas, dias',
                    disabled: true
                  }
                ]
              },
              {
                label: 'CONCLUSÃO',
                type: 'panel',
                key: 'conclusao',
                components: [
                  {
                    type: 'texteditor',
                    key: 'conclusao',
                    editorOption: {},
                    style: 'xs12'
                  }
                ]
              }
            ]
          },
          {
            label: 'MORFOLÓGICO',
            key: 'morfologico',
            components: [
              {
                label: 'INFORMAÇÕES',
                type: 'panel',
                key: 'exame',
                components: [
                  {
                    type: 'checkbox',
                    key: 'via',
                    label: 'Via do exame',
                    items: ['Abdominal', 'Transvaginal', 'Outros'],
                    style: 'xs12',
                    multiple: true
                  },
                  {
                    type: 'select',
                    key: 'indicacao',
                    label: 'Indicação do exame',
                    items: ['Datar gestação', 'Rastreio de aneuploidias', 'Sangramento', 'Diagnosticar gestação', 'Outros']
                  },
                  {
                    type: 'select',
                    key: 'qualidade',
                    label: 'Qualidade do exame',
                    items: ['Satisfatória', 'Prejudicado pela adiposidade materna', 'Prejudicado pela estática fetal', 'Prejudicado pela movimentação fetal', 'Outros']
                  }
                ]
              },
              {
                label: 'AVALIAÇÃO GESTAÇÃO',
                type: 'panel',
                key: 'avaliacaoGestacao',
                components: [
                  {
                    type: 'select',
                    key: 'fetos',
                    label: 'Fetos',
                    items: ['Gemelar', 'Triplo', 'Quádruplo', 'Outros'],
                    style: 'xs12 md6'
                  },
                  {
                    type: 'select',
                    key: 'situacaoFetal',
                    label: 'Situação fetal',
                    items: ['Longitudinal', 'Transversal', 'Oblíqua'],
                    style: 'xs12 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'corionicidade',
                    label: 'Corionicidade',
                    vShow: true
                  },
                  {
                    type: 'textfield',
                    key: 'amniocidade',
                    label: 'Amniocidade'
                  },
                  {
                    type: 'select',
                    key: 'apresentacaoFetal',
                    label: 'Apresentação fetal',
                    items: ['Cefálica', 'Pélvica', 'Córmica', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'dorsoFetal',
                    label: 'Dorso fetal',
                    items: ['Anterior', 'Posterior', 'Lateral direita', 'Lateral esquerda', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'movimentosFetais',
                    label: 'Movimentos fetais',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'batimentosFetais',
                    label: 'Batimentos fetais',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'textfield',
                    key: 'bcf',
                    label: 'BCF',
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'placenta',
                    label: 'Placenta',
                    items: ['Anterior', 'Posterior', 'Lateral direita', 'Lateral esquerda', 'Prévia parcial', 'Prévia total', 'Outros'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'placentaMaturidade',
                    label: 'Maturidade placentária(GRANUMM)',
                    items: ['0', 'I', 'II', 'III'],
                    style: 'xs12 md4'
                  }
                ]
              },
              {
                label: 'BIOMETRIA FETAL BÁSICA',
                type: 'panel',
                key: 'biometriaBasica',
                components: [
                  {
                    type: 'textfield',
                    key: 'diametroBiparietal',
                    label: 'Diâmetro biparietal',
                    suffix: 'mm',
                    style: 'xs6 md6',
                    chart: true
                  },
                  {
                    type: 'textfield',
                    key: 'circunferenciaCraniana',
                    label: 'Circunferência craniana',
                    suffix: 'mm',
                    style: 'xs6 md6',
                    chart: true
                  },
                  {
                    type: 'textfield',
                    key: 'circunferenciaAbdominal',
                    label: 'Circunferência abdominal',
                    suffix: 'mm',
                    style: 'xs6 md6',
                    chart: true
                  },
                  {
                    type: 'textfield',
                    key: 'comprimentoFemur',
                    label: 'Comprimento do fêmur',
                    suffix: 'mm',
                    style: 'xs6 md6',
                    chart: true
                  },
                  {
                    type: 'textfield',
                    key: 'comprimentoUmero',
                    label: 'Comprimento do úmero',
                    suffix: 'mm',
                    style: 'xs6 md6',
                    chart: true
                  },
                  {
                    type: 'textfield',
                    key: 'relacaoCCCA',
                    label: 'Relação CC/CA',
                    suffix: 'mm',
                    style: 'xs6 md6',
                    chart: true
                  },
                  {
                    type: 'textfield',
                    key: 'relacaoFemurCA',
                    label: 'Relação Fêmur/CA',
                    suffix: 'mm',
                    style: 'xs6 md6',
                    chart: true
                  },
                  {
                    type: 'textfield',
                    key: 'relacaoFemurCC',
                    label: 'Relação Fêmur/CC',
                    suffix: 'mm',
                    style: 'xs6 md6',
                    chart: true
                  },
                  {
                    type: 'textfield',
                    key: 'pesoEstimado',
                    label: 'Peso estimado (± 15%)',
                    suffix: 'g',
                    style: 'xs6 md6',
                    chart: true
                  },
                  {
                    type: 'textfield',
                    key: 'comprimentoEstimado',
                    label: 'Comprimento estimado',
                    suffix: 'cm',
                    style: 'xs12 md6',
                    chart: true
                  }
                ]
              },
              {
                label: 'BIOMETRIA FETAL AVANÇADA',
                type: 'panel',
                key: 'biometriaAvancada',
                components: [
                  {
                    type: 'textfield',
                    key: 'indiceCefalico',
                    label: 'Índice cefálico',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'diametroCerebelar',
                    label: 'Diâmetro cerebelar',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'circunferenciaAbdominal',
                    label: 'Circunferência abdominal',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'atrioVentriculoLateral',
                    label: 'Átrio do ventrículo lateral',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'cisternaMagna',
                    label: 'Cisterna magna',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'diametroOcular',
                    label: 'Diâmetro Ocular',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'distanciaInterocular',
                    label: 'Distância interocular',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'distanciaBinocular',
                    label: 'Distância Binocular',
                    suffix: 'mm',
                    style: 'xs6 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'quintoDedoMao',
                    label: 'Quinto dedo da mão',
                    suffix: 'mm',
                    style: 'xs12 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'ossoNasal',
                    label: 'Osso nasal',
                    suffix: 'mm',
                    style: 'xs12 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'pe',
                    label: 'Pé',
                    suffix: 'mm',
                    style: 'xs12 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'diamPalvisRenalDir',
                    label: 'Diâm. Pelvis renal dir',
                    suffix: 'mm',
                    style: 'xs12 md6'
                  },
                  {
                    type: 'textfield',
                    key: 'diamPalvisRenalEsq',
                    label: 'Diâm. Pelvis renal esq',
                    suffix: 'mm',
                    style: 'xs12 md6'
                  }
                ]
              },
              {
                label: 'ANATOMIA FETAL',
                key: 'anatomiaFetal',
                type: 'panel',
                components: [
                  {
                    type: 'radio',
                    key: 'cranio',
                    label: 'Crânio',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'cerebro',
                    label: 'Cérebro',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'face',
                    label: 'Face',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'pescoco',
                    label: 'Pescoço',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'colunaVertebral',
                    label: 'Coluna vertebral',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'caixaToracica',
                    label: 'Caixa torácica',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'pulmoesCavidadePleural',
                    label: 'Pulmões e cavidade pleural',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'coracaoEspacoPericardico',
                    label: 'Coração e espaço pericárdico',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'diafragma',
                    label: 'Diafragma',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'paredeAbdominal',
                    label: 'Parede abdominal',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'estomagoIntestino',
                    label: 'Estômago e intestino',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'rins',
                    label: 'Rins',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'Bexiga',
                    label: 'bexiga',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'outrosOrgãosAbdominais',
                    label: 'Outros órgãos abdominais',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'membros',
                    label: 'Membros',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'cordaoUmbilical',
                    label: 'Cordão umbilical',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  },
                  {
                    type: 'radio',
                    key: 'tecidoCelularSubcutaneo',
                    label: 'Tecido celular subcutâneo',
                    items: ['Normal', 'Alterado', 'Incerto'],
                    style: 'xs6 md4'
                  }
                ]
              },
              {
                label: 'AVALIAÇÃO BIOFÍSICA FETAL',
                type: 'panel',
                key: 'avalBiofisicaFetal',
                components: [
                  {
                    type: 'select',
                    key: 'movimentosRespiratorio',
                    label: 'Movimento respiratório',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'tonusFetal',
                    label: 'Tônus Fetal',
                    items: ['Presente', 'Ausente'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'select',
                    key: 'liquidoAmniotico',
                    label: 'Líquido amniótico',
                    items: ['Normal', 'Diminuído', 'Aumentado'],
                    style: 'xs12 md4'
                  },
                  {
                    type: 'label',
                    key: 'labelILA',
                    label: 'ILA',
                    style: 'xs12'
                  },
                  {
                    type: 'textfield',
                    key: 'qse',
                    label: 'QSE',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'qie',
                    label: 'QIE',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'qsd',
                    label: 'QSD',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'qiq',
                    label: 'QID',
                    suffix: 'mm',
                    style: 'xs6 md2'
                  },
                  {
                    type: 'textfield',
                    key: 'total',
                    label: 'Total',
                    suffix: 'mm',
                    disabled: true,
                    style: 'xs6 md4'
                  }
                ]
              },
              {
                label: 'IDADE GESTACIONAL',
                type: 'panel',
                key: 'idadeGestacional',
                components: [
                  {
                    type: 'textfield',
                    key: 'calculada',
                    label: 'Calculada',
                    suffix: 'Semanas, dias',
                    disabled: true
                  },
                  {
                    type: 'select',
                    key: 'calculo',
                    label: 'Cálculo',
                    items: ['Última menstruação', 'Exame anterior', 'Data provável do parto', 'Data implantação ovular', 'Informada pela paciente', 'Desconhecido']
                  },
                  {
                    type: 'textfield',
                    key: 'medida',
                    label: 'Medida neste exame',
                    suffix: 'Semanas, dias',
                    disabled: true
                  }
                ]
              },
              {
                label: 'CONCLUSÃO',
                type: 'panel',
                key: 'conclusao',
                components: [
                  {
                    type: 'texteditor',
                    key: 'conclusao',
                    editorOption: {},
                    style: 'xs12',
                    styleReport: 'xs12'
                  }
                ]
              }
            ]
          }
        ]
      },
      mainPanel: 'patient',
      editorOption: {},
      msg: 'Study',
      loading: true,
      studies: [{}],
      studiesHistory: [{}],
      slideIndex: null,
      report: {
        primeiroTriInit: {
          biometria: {sacoGestacional: { long: 0, ap: 0, transv: 0, result: 0 }},
          info: {via: [], indicacao: null, qualidade: null}
        },
        conclusao: {observacoes: ''}
      },
      menu: [
        {
          action: 'account_box',
          title: 'Informações',
          active: true,
          items: [
            { title: 'Paciente', panel: 'patient' },
            { title: 'Midia', panel: 'media' },
            { title: 'Histórico' }
          ]
        },
        {
          action: 'folder',
          title: 'Exames',
          items: [
            { title: '1º Trimestre Inicial', panel: 'priTriInicial' },
            { title: '1º Trimestre Rastreio', panel: 'priTriRastreio' },
            { title: '2º e 3º Trimestre', panel: 'segTerTriRastreio' },
            { title: 'Morfológico', panel: 'morfologico' },
            { title: 'Doppler Obstétrico' },
            { title: 'Perfil Biofísico' },
            { title: 'Cardiotocografia' }
          ]
        },
        {
          action: 'folder',
          title: 'Procedimentos Invasivos',
          items: [
            { title: 'Amniocentese' },
            { title: 'Cordocentese' },
            { title: 'Biópsia de Vilo' },
            { title: 'Fetoscopia' },
            { title: 'Laser' }
          ]
        },
        {
          action: 'folder',
          title: 'Ginecológico',
          items: [
            { title: 'Massa Anexial' },
            { title: 'Doppler Ginecológico' },
            { title: 'Endometriose Profunda' }
          ]
        },
        {
          action: 'folder',
          title: 'Controle de Ovulação',
          items: [
            { title: 'Primeiro Exame' },
            { title: 'Exame Subsequente' }
          ]
        },
        {
          action: 'folder',
          title: 'Mamas',
          items: [
            { title: 'Exame de Mamas' }
          ]
        },
        {
          action: 'assignment',
          title: 'Conclusão',
          items: [
            { title: 'Observações', panel: 'observations' },
            { title: 'Resumo', panel: 'preview' },
            { title: 'Impressão', panel: 'print' }
          ]
        }
      ]
    }
  },
  async mounted () {
    this.createEvents()
    this.id ? await this.find() : await this.findByPatIdAndServiceDate()
    await this.findByPatId()
    this.loading = false
    this.findImages()
  },
  filters: {
    componentValue (component, value) {
      if (value) {
        if (component.filter) {
          return component.filter(component, value)
        }
        if (component.type === 'select' || component.type === 'checkbox') {
          if (component.multiple) {
            return value.join(', ')
          }
        }
        if (component.prefix) {
          value = `${component.prefix} ${value}`
        }
        if (component.suffix) {
          value = `${value} ${component.suffix}`
        }
        return value
      }
    }
  },
  methods: {
    componentWeeksAndDays (component, value) {
      if (value) {
        let weeks = parseInt(value / 7)
        let days = Math.round(value % 7)
        return `${weeks} semanas e ${days} dias`
      }
    },
    createEvents: function () {
      // RESET
      this.forms.events = {}

      // VALUES
      let values = this.forms.values

      // FORMS
      this.forms.components.forEach(form => {
        form.components.forEach(panel => {
          panel.components.forEach(component => {
            if (component.formulas && component.formulas.authors) {
              // FORMULA
              let formula = component.formulas.authors[component.formulas.default]

              // PARAMS
              let paramCompKeys = []
              for (let param in formula.params) {
                let paramKey = formula.params[param]
                paramCompKeys.push(paramKey)
              }

              // KEY
              let resultCompKey = `${form.key}.${panel.key}.${component.key || component.label}`

              // NEW EVENT
              let event = () => {
                let params = {}
                for (let param in formula.params) {
                  let paramKey = formula.params[param]
                  let value = values[paramKey]
                  if (!value) {
                    values[resultCompKey] = ''
                    return
                  }
                  params[param] = value
                }
                axios
                  .post(`https://api.ultrahealth.care${formula.apiPath}`, params)
                  .then(response => {
                    values[resultCompKey] = response.data.result
                  })
                  .catch(function (error) {
                    values[resultCompKey] = error
                    console.log(error)
                  })
              }

              // Define EVENTS in params components
              paramCompKeys.forEach(paramKey => {
                let events = this.forms.events[paramKey]
                if (!events) {
                  this.forms.events[paramKey] = [event]
                } else {
                  events.push(event)
                }
              })
            }
          })
        })
      })
    },
    calcs (componentKey) {
      let componentEvents = this.forms.events[componentKey]
      if (componentEvents && componentEvents.length) {
        componentEvents.forEach(event => {
          event()
        })
      }
    },
    signOut () {
      auth.signOut()
        .then((res) => {
          this.$router.push('/login')
        })
        .catch((err) => {
          console.log(err)
        })
    },
    print () {
      window.print()
    },
    updateSacoGestacional (event) {
      let sacoInfo = this.report.primeiroTriInit.biometria.sacoGestacional
      sacoInfo.result = ((Number(sacoInfo.long) + Number(sacoInfo.ap) + Number(sacoInfo.transv)) / 3).toFixed(2)
    },
    find () {
      return axios.get(`https://www.ultravideo.com.br/companies/${this.company}/studies/${this.id}`)
      .then(res => {
        this.studies = [ res.data ]
      })
      .catch(err => {
        this.studies = [ {} ]
        console.error(err)
      })
    },
    findByPatId () {
      return axios.get(`https://www.ultravideo.com.br/companies/${this.company}/studies?patId=${this.patId}`)
      .then(res => {
        this.studiesHistory = StudyUtils.groupByDate(res.data.list)
      })
      .catch(err => {
        this.studiesHistory = [ {} ]
        console.log(err)
      })
    },
    findByPatIdAndServiceDate () {
      return axios.get(`https://www.ultravideo.com.br/companies/${this.company}/studies?patId=${this.patId}&serviceDate=${this.serviceDate}`)
      .then(res => {
        this.studies = res.data.list.sort((a, b) => { return (a.pathVideo + a.accessionNo).localeCompare(b.pathVideo + b.accessionNo) })
      })
      .catch(err => {
        this.studies = [ {} ]
        console.log(err)
      })
    },
    findImages () {
      const vm = this
      this.studies.forEach((item, index) => {
        // const studyUid = item.studyUid.replace(/\./g, '-')
        // const studyUid = '1-2-826-0-1-3680043-9-3782-82106659000191-746395'
        axios.get(`https://daascloud.com.br:8443/dcm4chee-arc/aets/DCM4CHEE/rs/studies${item.studyUid}/metadata`)
          .then(async res => {
            const data = res.data
            vm.$set(vm.studies[index], 'images', data)
            vm.$set(vm.studies[index], 'imagesURL', vm.mountImagesURL(data))
          })
          .catch(err => {
            item.images = {}
            item.imagesURL = []
            console.log(err)
          })
      })
    },
    mountImagesURL (images) {
      const urls = []
      images.forEach(item => urls.push(formatWadoRsToWado(item['7FE00010'].BulkDataURI, true)))
      return urls
    },
    video (study) {
      if (!study.pathVideo) return null
      return `https://www.ultravideo.com.br/player/${study.hashKey}`
    }
  }
}
</script>

<style scoped>
  .page-container {
    max-width: 1185px !important;
    padding-top: 75px;
    padding-bottom: 0;
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    flex: 1 1 100%;
    margin: auto;
    padding: 24px;
    width: 100%;
  }
  @media only screen and (min-width: 1264px) {
    .page-container {
      max-width: 1185px;
    }
  }
  @media only screen and (min-width: 960px) {
    .page-container {
      max-width: 900px;
    }
  }

  .blueimp-gallery-display {
    display: none;
  }
  .quill-editor >>> .ql-container {
    height: 350px;
  }
</style>

<style scoped>
  @media print {
    body * {
      visibility: hidden;
    }
    .printable, .printable * {
      visibility: visible;
    }
    .no-printable {
      display: none;
    }
    .printable {
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .slider-chart .v-slider__track-fill {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Report.vue